import "./Cgv.scss";

const CGV = () => {
  return (
    <div className="cgv-container">
      <h1>CONDITIONS GÉNÉRALES DE VENTE</h1>

      <section>
        <h2>Commandes</h2>
        <p>
          Les commandes ne sont valables que si elles sont acceptées par le
          siège de la société SP HYGIENE et ne deviennent définitives que par
          cette acceptation. Toute commande emporte, de plein droit, adhésion
          aux présentes conditions générales de vente qui prévalent sur tous
          autres documents et notamment les conditions générales d’achat,
          émanant de l’acheteur...
        </p>
      </section>

      <section>
        <h2>Prix</h2>
        <p>
          Les prix indiqués sont hors taxes, et établis en fonction des
          conditions économiques en vigueur...
        </p>
      </section>

      <section>
        <h2>Transport et livraison</h2>
        <p>
          Les marchandises sont réputées livrées une fois acheminées au lieu de
          livraison prévu lors de la prise de commande...
        </p>
      </section>

      <section>
        <h2>Retour de marchandises</h2>
        <p>
          Aucun retour n’est accepté sans notre accord préalable, ni au-delà
          d’un délai de huit jours suivants la date de réception des
          marchandises.
        </p>
      </section>

      <section>
        <h2>Conditions de paiement</h2>
        <p>
          Toute marchandises expédiées du 1er au 31 du mois, prend valeur du
          mois. Pour tout client ne possédant pas un compte ouvert...
        </p>
      </section>

      <section>
        <h2>Déchéance du terme</h2>
        <p>
          De convention expresse, en cas de report d’échéance, de protêt, de
          retour d’effet ou de retard de paiement d’une seule facture...
        </p>
      </section>

      <section>
        <h2>Pénalités de retard</h2>
        <p>
          Le non-respect des délais de paiement entraîne la facturation
          d’intérêts de retard exigibles...
        </p>
      </section>

      <section>
        <h2>Attribution de juridiction</h2>
        <p>
          Les tribunaux d’Evry sont, à l’exclusion de tous autres, seuls
          compétents en cas de litige...
        </p>
      </section>

      <footer>
        <p className="footer-contact">
          Z.I. la Prairie - 91140 Villebon-sur-Yvette - Tél. 01 69 34 92 28 –
          Fax 01 69 34 92 12 – info@sphygiene.com – www.sphygiene.com
        </p>
        <p className="footer-legal">
          S.A.S. au capital de 50 000€ - Siret : 504 144 965 00028 – Code APE :
          4649Z – N°TVA intracommunautaire: FR43504144965
        </p>
      </footer>
    </div>
  );
};

export default CGV;
